export const tUsers = [
  {
    author: "ahmed_fayyaz@outlook.com",
    createDateTime: "11/08/2020, 6:40:50 pm",
    forceWorker: "YES",
    key: "-MERfafvtg7AdNWI-YBj",
    recordType: "STANDARD USER",
    roleName: "SUPERADMIN",
    updateDateTime: "Wed 12-08-20 3:11 pm",
    userAddress: "SG",
    userCompany: "BCS SHOP",
    userEmail: "ismita@bcs.com.sg",
    userName: "Ismita"
  },
  {
    createDateTime: "03/08/2020, 2:02:56 pm",
    forceWorker: "YES",
    key: "-MDmUI_6VOQLD-DOBn64",
    recordType: "STANDARD USER",
    roleName: "STOREADMIN",
    updateDateTime: "03/08/2020 02:03:48",
    userAddress: "SG",
    userCompany: "BCS SHOP",
    userMobile: "91004975",
    userName: "Samita"
  },
  {
    compIntoText: "BCS ",
    createDateTime: "6/24/2020, 10:06:59 AM",
    forceWorker: "",
    key: "-MAZ4DNib4HJ3dfTdFRD",
    recordType: "STANDARD USER",
    roleName: "STOREADMIN",
    updateDateTime: "Wed 05-08-20 12:32 pm",
    userAddress: "12 lorong 14 geylang ",
    userCompany: "BCS SHOP",
    userMobile: "89059785",
    userName: "RABIUL"
  },
  {
    createDateTime: "11/06/2020, 12:48:08",
    forceWorker: "YES",
    key: "-M9WGubQrQe6v-e09yS2",
    recordType: "STANDARD USER",
    roleName: "STOREADMIN",
    updateDateTime: "19/06/2020 02:51:28",
    userAddress: "SG",
    userCompany: "BCS SHOP",
    userMobile: "84124637",
    userName: "ARIF"
  },
  {
    createDateTime: "11/06/2020, 12:46:46",
    forceWorker: "YES",
    key: "-M9WGaJFo5ekyw4nxHNT",
    recordType: "STANDARD USER",
    roleName: "STOREADMIN",
    updateDateTime: "19/06/2020 02:25:18",
    userAddress: "SG",
    userCompany: "BCS SHOP",
    userMobile: "89050302",
    userName: "IQBAL"
  },
  {
    bgImage: "bcsshot",
    compIntoText:
      "Home cook Bangladeshi food for family events at a reasonable price. ",
    createDateTime: "06/06/2020, 03:05:42",
    forceWorker: "",
    key: "-M94Rpcyodb7D6vx3MQQ",
    recordType: "STANDARD USER",
    roleName: "STOREADMIN",
    sortOrder: "9",
    updateDateTime: "29/06/2020 06:35:47",
    userAddress: "AU",
    userCompany: "",
    userMobile: "97861234",
    userName: "Ahmed Test"
  },
  {
    action1: "openBazarList",
    bgImage:
      "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F67446270-b1c5-11ea-b3a7-b78f6358f9d9.jpg?alt=media&token=119bb924-d06c-4fb0-9b5e-b2f83c51de82",
    btn1Text: "ENTER OPEN BAZAR NOW",
    compIntoText: "ENTER",
    createDateTime: "06/06/2020, 01:10:34",
    forceWorker: "YES",
    key: "-M941QVE3u0_jRZg1gAO",
    promoDescription: "Ask or offer help, buy, Sell and share the joy",
    promoHeader: "OPEN BAZAR",
    recordType: "PROMOTIONAL",
    roleName: "WORKER",
    sortOrder: "2",
    tableName: "openBazar",
    updateDateTime: "01/07/2020 12:13:27",
    userAddress: "SG",
    userCompany: "",
    userName: "OPEN BAZAR"
  },
  {
    action1: "shopFromASupplier",
    action2: "orderlist",
    bgImage: "bcsshop",
    btn1Text: "SHOP NOW",
    btn2Text: "VIEW ORDERS",
    compIntoText: "SHOP NOW",
    createDateTime: "06/06/2020, 01:07:01",
    forceWorker: "YES",
    key: "-M9417tDiDRdz8761a1M",
    promoDescription: "Tap Shop Now or call us at +65 9456 2455 ",
    promoHeader: "BUY GROCERY AND MORE",
    recordType: "PROMOTIONAL",
    roleName: "WORKER",
    sortOrder: "1",
    tableName: "supplierShopItems",
    tableName2: "deliveryRequest",
    updateDateTime: "01/07/2020 04:04:44",
    userAddress: "SG",
    userCompany: "BCS SHOP",
    userName: "BCS SHOP"
  },
  {
    author: "ahmed_fayyaz@outlook.com",
    createDateTime: "20/05/2020, 23:36:23",
    password: "review",
    roleName: "STOREADMIN",
    updateDateTime: "20/05/2020 11:37:49",
    userAddress: "US",
    userCompany: "APPLE",
    userEmail: "apple@bcs.com",
    userMobile: "98764444",
    userName: "Apple Review",
    key: "-M7mIUIObJ5zQjme1Chz"
  },
  {
    createDateTime: "20/05/2020, 19:55:28",
    key: "-M7mIR64HDztc9hUpkqB",
    password: "p123456",
    recordType: "",
    roleName: "STOREADMIN",
    updateDateTime: "11/06/2020 12:45:26",
    userAddress: "35 Desker road Singapore 206795",
    userCompany: "KASH PHUL PTE LTD",
    userDesignation: "Manager ",
    userEmail: "kashphul@bcs.com",
    userFin: "G3257975u",
    userMobile: "98918844",
    userName: "Sam ",
    userNationality: "BANGLADESH"
  },
  {
    author: "ahmed_fayyaz@outlook.com",
    createDateTime: "19/05/2020, 00:15:04",
    password: "p123456",
    roleName: "STOREADMIN",
    updateDateTime: "19/05/2020 12:16:10",
    userAddress: "sg",
    userCompany: "Live TV (Coming Soon)",
    userEmail: "supp1@bcs.com",
    userMobile: "97861239",
    userName: "Ahmed",
    userNationality: "SINGAPORE",
    key: "-M7c84iK3kpjcX-RErH4"
  },
  {
    createDateTime: "18/05/2020, 12:12:18",
    key: "-M7_Yf3DkOc9msPgzNKW",
    password: "ferdous1",
    recordType: "",
    roleName: "STOREADMIN",
    sortOrder: "5",
    updateDateTime: "11/06/2020 12:43:38",
    userAddress: "Ferdous Khan Products Grocery",
    userCompany: "FERDOUS KHAN PRODUCTS GROCERY",
    userEmail: "ferdous@bcs.com",
    userMobile: "98537192",
    userName: "Ferdous Khan"
  },
  {
    author: "ahmed_fayyaz@outlook.com",
    createDateTime: "14/05/2020, 00:11:02",
    password: "review1",
    roleName: "STOREADMIN",
    updateDateTime: "14/05/2020 12:12:00",
    userAddress: "review",
    userCompany: "Google",
    userEmail: "review@bcs.com",
    userMobile: "98764444",
    userName: "Google Reviewer",
    key: "-M7DNAn9Ojwl2_Xhhtwq"
  },
  {
    createDateTime: "13/05/2020, 18:42:05",
    key: "-M7CCBK63TQATDLysfci",
    password: "tanmoy1",
    recordType: "",
    roleName: "STOREADMIN",
    sortOrder: "4",
    updateDateTime: "11/06/2020 12:43:53",
    userAddress: "Tanmoy SG",
    userCompany: "TANMOY",
    userEmail: "tanmoy@bcs.com",
    userMobile: "96220740",
    userName: "Moni"
  },
  {
    author: "ahmed_fayyaz@outlook.com",
    createDateTime: "12/05/2020, 15:37:43",
    password: "donnie100",
    roleName: "ORDERADMIN",
    updateDateTime: "12/05/2020 03:38:53",
    userAddress: "SG",
    userCompany: "Donnie",
    userEmail: "donnie@bcs.com",
    userMobile: "86693532",
    userName: "Donnie",
    key: "-M76O8hvM4XAOcwB7zMT"
  },
  {
    createDateTime: "12/05/2020, 15:34:00",
    key: "-M76NCv43POTmJsAagwB",
    password: "p123456",
    roleName: "STOREADMIN",
    updateDateTime: "16/06/2020 07:36:08",
    userAddress: "SG",
    userCompany: "BCS SHOP",
    userEmail: "kabir@bcs.com",
    userMobile: "94562455",
    userName: "Kabir"
  },
  {
    createDateTime: "11/05/2020, 13:41:36",
    key: "-M70ozM98C0SlaHVaj0W",
    password: "lamiah",
    recordType: "",
    roleName: "STOREADMIN",
    sortOrder: "6",
    updateDateTime: "11/06/2020 12:43:59",
    userAddress: "Tuas south ave 6 Singapore 637779",
    userCompany: "Lamiah Enterprise Pte Ltd",
    userEmail: "lamiah@bcs.com",
    userMobile: "82206632",
    userName: "Lamiah Enterprise Pte Ltd"
  },
  {
    author: "ahmed_fayyaz@outlook.com",
    createDateTime: "27/04/2020, 18:11:24",
    password: "foodPass",
    roleName: "WORKER",
    updateDateTime: "27/04/2020 06:12:18",
    userAddress: "some address",
    userCompany: "BROOKLYNZ STAINLESS STEEL PTE LTD",
    userDesignation: "",
    userEmail: "worker@worker.com.sg",
    userFin: "",
    userMobile: "",
    userName: "WORKERS",
    userNationality: "",
    userWorkPermit: "",
    key: "-M5ugPqf18ttmq9ZsiP-"
  },
  {
    key: "1",
    password: "sdf",
    recordType: "STANDARD USER",
    roleName: "SUPERADMIN",
    updateDateTime: "15/06/2020 05:37:33",
    userAddress: "Sydney Australia",
    userCompany: "BCS SHOP",
    userDesignation: "Technology",
    userEmail: "ahmed_fayyaz@outlook.com",
    userEmployeeId: "0",
    userFin: "G6050046R",
    userMobile: "97861239",
    userName: "Ahmed Fayyaz",
    userNotes: "some notes again",
    userWorkPermit: "NA"
  },
  {
    createDateTime: "",
    key: "0",
    lastAction: "",
    recordType: "STANDARD USER",
    roleName: "STOREADMIN",
    sortDateTime: 8469394345473,
    updateDateTime: "30/06/2020 10:53:05",
    userAddress: "sg",
    userCompany: "TECHNO STEEL",
    userDesignation: "Technlogy",
    userEmail: "ahmed_fayyaz2@outlook.com",
    userEmployeeId: "XXX",
    userMobile: "+923465379140",
    userName: "Ahmed Fayyaz",
    userNotes: "some thing"
  }
];



// WEBPACK FOOTER //
// ./src/staticData/tUsers.js